import React from 'react'

import ProjectsReorderList from "../projects-reorder-list"
import NavigationMenuAddWithPopover from "../../../menu-items/menu-add-with-popover/menu-add"
import {
    NavigationMenuInlineAddParams,
    NavigationMenuInlineAddType
} from "../../../menu-items/menu-add-with-popover/popover"
import NavigationMenu_ProjectsLocalSettings from "../../../local-settings"
import ProjectSession from "../../../../../core/model2/project/project-session"
import NavigationMenu_ProjectsInlineAdd from "./inline-add"
import {SpaceProto} from "../../../../../core/model2/space/space-proto";
import Workspace from "../../../../../core/model2/space/workspaces/workspace";

// const debug = "NavigationMenuProjectsTree"
const debug = false

type Props = {
    showAdd             : boolean
    localSettings       : NavigationMenu_ProjectsLocalSettings
    // workspace?          : ProjectSession

    space               : SpaceProto
}

type State = {
    inlineType?         : NavigationMenuInlineAddType,
    templateId?         : ID
    params              : any
}

export default class NavigationMenu_ProjectsTree extends React.Component<Props, State> {

    static defaultProps = {
        showAdd: true
    }

    constructor(props:Props) {
        super(props)

        this.state = {
            inlineType      : undefined,
            templateId      : undefined,
            params          : undefined
        }
    }

    onAddInline = (inlineType: NavigationMenuInlineAddType, params: NavigationMenuInlineAddParams) => {
        debug && console.log(debug, 'onAddInline', inlineType, params)

        this.setState({
            inlineType  : inlineType,
            params      : params, // for folder, page and embed
        })
    }

    onInlineAdded = (isAdded: boolean) => {
        debug && console.log(debug, 'onInlineAdded', isAdded)

        this.setState({
            inlineType  : undefined,
            params      : undefined,
        })
    }

    render() {


        debug && console.log(debug, 'render() space=', this.props.space, this.props.localSettings)

        const showAddButton = this.props.showAdd && !this.state.inlineType && gd.ac.check.canCreateProject(gd.companyId) && gd.ac.check.createRootProject()

        let parentId        : any = (this.props.space.isWorkspace) ? this.props.space.id : 'root'
        let rootProjects    : ProjectSession[] = []
        const workspace     : Workspace | null = (this.props.space.isWorkspace) ? this.props.space as Workspace : null

        if (workspace) {
            rootProjects = workspace.rootProjects
        } else {
            rootProjects = gd.session.projects.treeRootsNotWorkspaces
        }

        debug && console.log(debug, '    rootProjects=', rootProjects)

        // make sure we do not show root projects which are starred
        const starredProjects : ID[] = gd.session.starredItems.getProjectsIds() || []
        rootProjects = _.filter(rootProjects, (project:ProjectSession)=>{
            return !starredProjects.includes(project.id)
        })


        return (
            <div className="m-b-20">
                <div className="projects-tree-container">
                    <ProjectsReorderList level              = {0}
                                         space              = {this.props.space}
                                         parentId           = {parentId}
                                         projects           = {rootProjects}
                                         localSettings      = {this.props.localSettings}/>
                </div>

                {showAddButton &&
                    <NavigationMenuAddWithPopover label         = "New"
                                                  projectId     = {workspace?.project.id}
                                                  onAddInline   = {this.onAddInline}/>
                }

                {this.state.inlineType &&
                    <NavigationMenu_ProjectsInlineAdd callback={this.onInlineAdded}
                                                      parentId={workspace?.project.id}
                                                      params={this.state.params}
                                                      type={this.state.inlineType} />
                }
            </div>
        )
    }
}
